<div [ngClass]="{ container: padding }">
  <div class="top-header row">
    <!-- SHOP BY ARTIST DROPDOWN -->
    <div class="col-md-6 artist-select">
      <ng-select
        [items]="showArtists"
        bindLabel="name"
        bindValue="url_alias"
        (change)="onChange($event)"
        placeholder="Shop By Artist"
      >
        <ng-template ng-option-tmp let-item="item">
          <span>{{ item.name }}</span>
          <!-- <span class="non-pv" *ngIf="item.status == 'NONPV' && item.sort_name != 'Polyvinyl'">
            &nbsp;&nbsp;(Non PV)
          </span> -->
        </ng-template>

      </ng-select>
    </div>

    <!-- SEARCH STORE -->
    <div class="col-md-6">
      <pv-store-search></pv-store-search>
    </div>
  </div>
</div>
